import apiReward from '@/api/vo/reward';

const defaultState = () => ({
	listRewardTitik: [],
	rewardTitikPagination: '',
	listHistoryRewardTitik: [],
	historyRewardTitikPagination: '',

	listRewardPribadi: [],
	rewardPribadiPagination: '',
	listHistoryRewardPribadi: [],
	historyRewardPribadiPagination: '',

	listRewardGroup: [],
	rewardGroupPagination: '',
	listHistoryRewardGroup: [],
	historyRewardGroupPagination: '',
	listHistoryRewardPoint: [],

	responSukses: {},
	responseError: {},
	konfirmResponse: {},
});

const state = defaultState();

const getters = {

};

const mutations = {

	setRewardTitik(state, data) {
		state.listRewardTitik = data.data;
		state.rewardTitikPagination = data.pagination;
	},
	setHistoryRewardTitik(state, data) {
		state.listHistoryRewardTitik = data.data;
		state.historyRewardTitikPagination = data.pagination;
	},

	setRewardPribadi(state, data) {
		state.listRewardPribadi = data.data;
		state.rewardPribadiPagination = data.pagination;
	},
	setHistoryRewardPribadi(state, data) {
		state.listHistoryRewardPribadi = data.data;
		state.historyRewardPribadiPagination = data.pagination;
	},

	setRewardGroup(state, data) {
		state.listRewardGroup = data.data;
		state.rewardGroupPagination = data.pagination;
	},
	setHistoryRewardGroup(state, data) {
		state.listHistoryRewardGroup = data.data;
		state.historyRewardGroupPagination = data.pagination;
	},
	setHistoryRewardPoint(state, data) {
		state.listHistoryRewardPoint = data.data;
	},

	saveResponseError(state, data) {
		state.responseError = data;
	},
	saveResponse(state, data) {
		state.responSukses = data
		state.responseError = ''
	},
};

const actions = {

	getRewardTitik({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getRewardTitik(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setRewardTitik', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setRewardTitik', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getHistoryRewardTitik({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getHistoryRewardTitik(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setHistoryRewardTitik', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setHistoryRewardTitik', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getRewardPribadi({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getRewardPribadi(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setRewardPribadi', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setRewardPribadi', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getHistoryRewardPribadi({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getHistoryRewardPribadi(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setHistoryRewardPribadi', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setHistoryRewardPribadi', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getRewardGroup({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getRewardGroup(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setRewardGroup', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setRewardGroup', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getHistoryRewardGroup({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getHistoryRewardGroup(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setHistoryRewardGroup', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setHistoryRewardGroup', { data: [], pagination: {} });
				reject()
			});
		});
	},
	
	getHistoryRewardPoint({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getHistoryRewardPoint(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setHistoryRewardPoint', data.results)
					resolve(data.results)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setHistoryRewardPoint', []);
				reject()
			});
		});
	},

	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},

	errorHandler({ commit }, response) {
		if (response.status !== undefined && response.status === 'unauthorized') {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.msg
			}, { root: true });
		} else {
			switch (response.error_code) {
				case 'validationError':
					commit('setErrorValidation', response.results.validationMessage)
					break;
					
				case 'ERROR':
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: response.message
					}, { root: true });
					break;
						
				default:
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: 'Terjadi Kesalahan pada sistem, hubungi administrator atau layanan mitra ' + (process.env.VUE_APP_CLIENT_INIT !== undefined) ? process.env.VUE_APP_CLIENT_INIT : 'perusahaan'
					}, { root: true });
					break;
			}
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};